import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateEmailOptionsCompose = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 531.73 500",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{opacity:.1;}.d{fill:#044e28;}.e{fill:#fafcff;}.f{fill:#fff1d6;}.g{fill:#940a0a;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "e",
				cx: 280.84,
				cy: 253.53,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
				className: "f",
				x: 102.71,
				y: 179.04,
				width: 359.36,
				height: 223.21,
				rx: 10.91,
				ry: 10.91
			}), /* @__PURE__ */ _jsx("path", {
				className: "g",
				d: "M390.64,353.65l-65.22-57.08,62.48-53.78c3.66-3.15,4.07-8.66,.92-12.31-3.15-3.66-8.66-4.07-12.31-.92l-94.12,81.01-94.12-81.01c-3.65-3.15-9.17-2.73-12.31,.92-3.14,3.66-2.73,9.17,.92,12.31l62.48,53.78-65.22,57.08c-3.63,3.18-4,8.69-.82,12.32,3.18,3.63,8.69,4,12.32,.82l67.09-58.72,23.36,20.11c1.78,1.53,4.01,2.19,6.19,2.07,.04,0,.08,.01,.12,.01,.04,0,.08-.01,.12-.01,2.18,.12,4.4-.54,6.19-2.07l23.36-20.11,67.09,58.72c3.63,3.18,9.14,2.81,12.32-.82,3.18-3.63,2.81-9.15-.82-12.32Z"
			})] }), /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("circle", {
					className: "c",
					cx: 448.82,
					cy: 190.71,
					r: 54
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "d",
					cx: 453.36,
					cy: 186.23,
					r: 54
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M479.84,167.26l-21.04-12.15c-1.42-.82-3.19,.2-3.19,1.84v7.51h-16.02c-1.17,0-2.12,.95-2.12,2.12v5.03c0,1.17,.95,2.12,2.12,2.12h16.02v7.51c0,1.64,1.77,2.66,3.19,1.84l21.04-12.15c1.42-.82,1.42-2.86,0-3.68Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M426.89,201.53l21.04-12.15c1.42-.82,3.19,.2,3.19,1.84v7.51h16.02c1.17,0,2.12,.95,2.12,2.12v5.03c0,1.17-.95,2.12-2.12,2.12h-16.02v7.51c0,1.64-1.77,2.66-3.19,1.84l-21.04-12.15c-1.42-.82-1.42-2.86,0-3.68Z"
				})] })
			] })]
		})
	]
});
export default SvgEmptyStateEmailOptionsCompose;
